module.exports = __webpack_public_path__ + "/static/node_modules/leaflet/dist/images/marker-icon-2x.401d815dc206b8dc1b17cd0e37695975.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/marker-icon-2x.png
// module id = qXhe
// module chunks = 1